<!-- 全县三夏机收完成进度 -->
<template>
  <div class="chart">
    <div class="legend">
      <span>目标</span>
      <span>完成</span>
    </div>
    <div :id="id" :class="className" :style="{ height: height, width: width }" />
  </div>
</template>

<script>
import * as echarts from 'echarts';
import resize from '@/components/chart/mixins/resize';
import { CHART_CONFIG_SECTION } from './constants';

let chartVm = null;
const MIN_SCROLL_COUNT = 10; // 达到这个数值后才滚动
const LINNER_COLOR = {
  default: new echarts.graphic.LinearGradient(
    0,
    1,
    1,
    0,
    [
      {
        offset: 0,
        color: 'rgba(199, 255, 219, 1)', // 0% 处的颜色 绿
      },
      {
        offset: 1,
        color: 'rgba(0, 193, 68, 1)', // 100% 处的颜色 绿
      },
    ],
    false
  ),
  warning: new echarts.graphic.LinearGradient(
    0,
    1,
    1,
    0,
    [
      {
        offset: 0,
        color: 'rgba(255, 233, 198, 1)', // 0% 处的颜色 橙
      },
      {
        offset: 1,
        color: 'rgba(255, 157, 0, 1)', // 100% 处的颜色 橙
      },
    ],
    false
  ),
};

const OPTIONS = Object.freeze({
  grid: {
    left: 80,
    top: 0,
    right: 50,
    bottom: 20,
  },
  legend: {
    show: false,
    // data: ['目标', '完成'],
    right: 45,
    top: 0,
    icon: 'rect',
    itemWidth: 8,
    itemHeight: 6,
    textStyle: {
      color: '#fff',
      fontSize: 12,
      align: 'left',
      verticalAlign: 'middle',
    },
  },
  tooltip: {
    trigger: 'axis',
    backgroundColor: 'rgba(0, 50, 17, 0.71)',
    axisPointer: {
      type: 'none', // 设置为 'none' 去除水平线
    },
    // formatter: '{b0}: {c0}<br />{b1}: {c1}',
    formatter: CHART_CONFIG_SECTION.tooltipFormatter({ unit: '亩', border: 'none', borderRadius: 0, direction: 'right', height: '4px' }),
    // formatter: function (params) {
    //   console.log('tooltip', { params });
    //   return params[0].name + '<br>' + params[0].marker + '' + params[0].seriesName + '：' + +params[0].value + '亩' + '<br>' + params[1].marker + '' + params[1].seriesName + '：' + params[1].value + '亩' + '\n';
    // },
  },
  dataZoom: [
    {
      type: 'slider',
      yAxisIndex: 0,
      startValue: 0,
      endValue: MIN_SCROLL_COUNT > 2 ? MIN_SCROLL_COUNT - 1 : 1,
      zoomLock: true,
      show: false,
    },
  ],
  xAxis: {
    name: '亩',
    nameTextStyle: {
      color: '#BABBBD',
      fontSize: 12,
      align: 'right',
      verticalAlign: 'top', // 底部对齐
      padding: [10, -30, 0, 0, 0],
    },
    nameLocation: 'end',
    splitLine: {
      show: true,
      lineStyle: {
        type: 'dashed',
        color: ['rgba(164, 218, 255, 0.2)'],
      },
    },
    axisLine: {
      show: false,
    },
    axisLabel: {
      show: true,
      fontFamily: 'Microsoft YaHei',
      color: '#FDFEFF',
      fontSize: 12,
    },
    axisTick: {
      show: false,
    },
  },
  yAxis: {
    type: 'category',
    axisLine: {
      show: false,
      lineStyle: {
        type: 'solid',
        width: 3,
        color: 'rgba(164, 218, 255, 0.2)',
      },
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      show: true,
      fontFamily: 'Microsoft YaHei',
      color: '#FFFFFF',
      fontSize: 12,
      interval: 0,
    },
    position: 'left',
    data: [],
  },
});

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    id: {
      type: String,
      default: 'completionProgress',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    progresses: {
      type: Array,
      default: () => [],
    },
    interval: {
      type: Number,
      default: 2000,
    },
  },
  data() {
    let self = this;
    return {
      chart: null,
      config: self.progresses,
    };
  },
  computed: {
    progressesSign() {
      let self = this;
      let sign = JSON.stringify(self.progresses);
      return sign;
    },
  },
  watch: {
    progressesSign: {
      handler(v) {
        let self = this;
        let config = JSON.parse(v || '[]');
        self.config = config;
        self.initChart();
        // console.log('%cRightFirst.watch.props.progresses', 'color:#CC0', config);
      },
      deep: true,
    },
    scrollTimer: null,
  },
  methods: {
    buildEChartOption() {
      let self = this;
      let series = [];
      series.push({
        name: '目标',
        type: 'bar',
        barWidth: 10,
        stack: '总量',
        barGap: '-100%',
        itemStyle: {
          normal: {
            barBorderRadius: [0, 10, 10, 0],
            color: function (params) {
              const name = params.name;
              const hasWarn = self.progresses.find((v) => v.areaName == name).warnCount > 0;
              // console.log('%c chart.itemStyle.normal.color', 'color:#0CC', { params, hasWarn });
              return !hasWarn ? '#00551E' : 'rgba(110, 69, 3, 1)';
            },
          },
        },
        data: self.config.map((v) => v.plantingArea),
        z: 0,
      });
      series.push({
        name: '完成',
        type: 'bar',
        barWidth: 10,
        legendHoverLink: false,
        label: {
          show: true,
          position: 'right',
          fontWeight: 'bolder',
          align: 'left',
          // offset: [30, 0],
          formatter: (p) => {
            var info = self.config.filter((item) => {
              return p.name == item.areaName;
            })[0];
            return `{a|${info.progress}%}`;
          },
          rich: {
            a: {
              color: '#fff',
              fontSize: 12,
            },
          },
        },
        itemStyle: {
          //lenged文本
          opacity: 1,
          barBorderRadius: [0, 10, 10, 0],
          color: function (params) {
            const name = params.name;
            const hasWarn = self.progresses.find((v) => v.areaName == name).warnCount > 0;
            // console.log('%c chart.itemStyle.color', 'color:#0CC', { params, hasWarn });
            return hasWarn ? LINNER_COLOR.warning : LINNER_COLOR.default;
          },
        },
        data: self.config
          .map((v) => v.completedArea)
          .map((v) => ({
            value: v,
          })),
        z: 1,
      });
      let option = { ...OPTIONS };
      option.yAxis.data = self.config.map((v) => v.areaName);
      option.series = series;
      // console.log('%c全县三夏机收完成进度.echartOptions', 'color:#CC0', option);
      self.setEChartOption(option);
    },
    setEChartOption(option) {
      let self = this;
      self.chart.setOption(option, {
        notMerge: true, // 是否不跟之前设置的 option 进行合并。默认为 false。即表示合并。
        lazyUpdate: false, // 在设置完 option 后是否不立即更新图表，默认为 false，即同步立即更新。如果为 true，则会在下一个 animation frame 中，才更新图表。
      });
    },
    initChart() {
      let self = this;
      if (!self.chart) {
        self.chart = echarts.init(document.getElementById(self.id));
      }
      self.scroll();
      self.buildEChartOption();
      self.chart.on('mouseover', () => {
        self.stopScroll();
      });
      self.chart.on('mouseout', () => {
        self.scroll();
      });
    },
    scroll() {
      let self = this;
      if (self.progresses.length < MIN_SCROLL_COUNT) {
        // console.log('%c机收完成进度.未自动滚动', 'color:#C00', { 收到记录数: self.progresses.length, 最少条数: MIN_SCROLL_COUNT });
        return;
      } else {
        // console.log('%c机收完成进度.自动滚动', 'color:#CC0', { 收到记录数: self.progresses.length, 最少条数: MIN_SCROLL_COUNT });
      }
      if (self.scrollTimer) {
        clearTimeout(self.scrollTimer);
        self.scrollTimer = null;
      }
      self.scrollTimer = setInterval(function () {
        // console.log('%c全县三夏机收完成进度.scroll.scrollTimer', 'color:#cc0', { interval: self.interval, chart: self.chart });
        if (!self.chart) {
          self.initChart();
          return;
        }
        const echartOption = self.chart.getOption();
        let config = echartOption; // JSON.parse(JSON.stringify(echartOption));
        config.yAxis[0].data.push(config.yAxis[0].data.shift());
        config.series.forEach((_, i) => {
          config.series[i].data.push(config.series[i].data.shift());
        });
        // config.areaNames && config.areaNames.push(config.areaNames.shift());
        // config.total && config.total.push(config.total.shift());
        // config.complete && config.complete.push(config.complete.shift());
        // config.ratio && config.ratio.push(config.ratio.shift());
        // config.originalData && config.originalData.push(config.originalData.shift());
        self.setEChartOption(config);
      }, self.interval || 3000);
    },
    stopScroll() {
      let self = this;
      if (self.scrollTimer) {
        clearTimeout(self.scrollTimer);
        self.scrollTimer = null;
      }
    },
  },
  created() {},
  // activated() {
  //   this.$nextTick(function () {
  //     setTimeout(() => {
  //       this.chart.resize();
  //     }, 300);
  //   });
  // },
  mounted() {
    this.initChart();
    chartVm = this;
  },
  beforeDestroy() {
    let self = this;
    self.$emit('clearInterval');
    self.stopScroll();
    if (!self.chart) {
      return;
    }
    self.chart.dispose();
    self.chart = null;
  },
};
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}
.chart {
  height: 100%;
  width: 100%;
  padding-left: vw(5);
  .legend {
    text-align: right;
    padding-right: vw(40);
    transform: translateY(vh(-4));
    span {
      position: relative;
      color: #fff;
      font-size: fontSize(12);
      padding-left: vw(16);
      margin-left: vw(15);
      &::before,
      &::after {
        content: '';
        display: inline-block;
        position: absolute;
        width: vw(6);
        height: vh(4);
        top: vh(6);
      }
      &::before {
        left: 0;
        background: #00c144;
      }
      &::after {
        left: vw(6);
        background: #ff9d00;
      }
      &:first-child {
        &::before,
        &::after {
          opacity: 0.5;
        }
      }
    }
  }
}
</style>
